import {
  getApplicationListV2,
  getServiceCollections,
  getServiceCollectionSubscriptionStatusForIdentity,
} from "../../actions/api";
import React, { useCallback, useEffect, useState } from "react";
import { List, Space, Tooltip, Button } from "antd";
import { PageHeader1 } from "../headers/PageHeaders";
import {
  ClusterOutlined,
  SettingOutlined,
  EditOutlined,
} from "@ant-design/icons";
import { connect, useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { selectHasRole } from "./UtilsAdmin";
import ServiceCollectionCreateModal from "./ServiceCollectionCreateModal";
import { service_admin_role, applicationPortal } from "../../config";
import PropTypes from "prop-types";
import UserStatusModal from "./UserStatusModal";

const ServiceCollectionListAdmin = ({
  getServiceCollectionSubscriptionStatusForIdentity,
}) => {
  const dispatch = useDispatch();
  const [serviceCollections, setServiceCollections] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const isServiceAdmin = useSelector(selectHasRole(service_admin_role));

  const fetchCollections = useCallback(async () => {
    setIsLoading(true);
    setServiceCollections([]);

    const collections = await dispatch(getServiceCollections());
    const applications = await dispatch(getApplicationListV2());
    if (collections?.payload?.data) {
      if (isServiceAdmin) setServiceCollections(collections.payload.data);
      else if (applications?.payload?.data)
        setServiceCollections(
          collections.payload.data.filter((x) =>
            applications.payload.data.some(
              (x2) => x.applicationIdentifier === x2.applicationIdentifier,
            ),
          ),
        );
    }
    setIsLoading(false);
  }, [dispatch, isServiceAdmin]);

  useEffect(() => {
    fetchCollections();
  }, [fetchCollections]);

  return (
    <div>
      <PageHeader1
        title="Eligibility Services"
        subTitle="Top level service for which eligibility applies, that will contain applications and resources."
        icon={<ClusterOutlined />}
      />

      <List
        loading={isLoading}
        dataSource={serviceCollections}
        renderItem={(item) => (
          <List.Item
            actions={[
              <UserStatusModal
                key="zz0"
                application={item}
                getStatusForIdentity={
                  getServiceCollectionSubscriptionStatusForIdentity
                }
              />,
              <Tooltip
                key="zz1"
                title="Edit this Service Collection in the Application Portal"
              >
                <Button
                  disabled={!isServiceAdmin}
                  icon={<EditOutlined />}
                  href={`${applicationPortal}manage/${item.applicationIdentifier}`}
                  target="_blank"
                />
              </Tooltip>,
              <Tooltip key="zz2" title="Edit Eligibility Settings">
                <NavLink to={`/manage/${item.applicationIdentifier}/edit`}>
                  <Button
                    disabled={!isServiceAdmin}
                    icon={<SettingOutlined />}
                  />
                </NavLink>
              </Tooltip>,
            ]}
          >
            <List.Item.Meta
              title={
                <Space>
                  <Tooltip title="View and manage applications in this Service Collection">
                    <NavLink to={`/manage/${item.applicationIdentifier}`}>
                      {item.displayName}
                    </NavLink>
                  </Tooltip>
                </Space>
              }
              description={item.description}
            />
          </List.Item>
        )}
        locale={{
          emptyText:
            "No service collections with admin rights are available for you. If you think this is an error, please contact Service Desk.",
        }}
      />

      <div
        style={{
          backgroundColor: "#f3f4f5",
          padding: "5px",
        }}
      >
        <ServiceCollectionCreateModal isAdmin={isServiceAdmin} />
      </div>
    </div>
  );
};

ServiceCollectionListAdmin.propTypes = {
  getServiceCollectionSubscriptionStatusForIdentity: PropTypes.func.isRequired,
};

export default connect(() => {}, {
  getServiceCollectionSubscriptionStatusForIdentity,
})(ServiceCollectionListAdmin);
